export interface NotificationsState {
  sendNotifications: boolean
}

export type NotificationsDispatch = (arg0: NotificationsAction) => void

export type NotificationsAction = {
  type: 'TOGGLE_SEND_NOTIFICATIONS'
  sendNotifications: boolean
}

export function initialNotificationsState(): NotificationsState {
  return {
    sendNotifications: true,
  }
}

export default function reducer(
  state: NotificationsState,
  action: NotificationsAction
): NotificationsState {
  switch (action.type) {
    case 'TOGGLE_SEND_NOTIFICATIONS':
      return { ...state, sendNotifications: action.sendNotifications }

    default:
      return state
  }
}
